import { render } from "./PageLoading.vue?vue&type=template&id=7e7ef138"
const script = {}
script.render = render

export default script